import React, { useState, useEffect } from 'react';
import { FaCalendarAlt, FaUser, FaClock, FaMapMarkerAlt, FaArrowLeft, FaArrowRight, FaPlus, FaCheck, FaSpinner } from 'react-icons/fa';
import '../style/css/OrderTable.css'; // הנתיב של קובץ ה-CSS


const OrderTable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [customDate, setCustomDate] = useState(null);
    const [selectedQuantity, setSelectedQuantity] = useState(null);
    const [customQuantity, setCustomQuantity] = useState('');
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedArea, setSelectedArea] = useState(null);
    const [showDateOptions, setShowDateOptions] = useState(false);
    const [showQuantityInput, setShowQuantityInput] = useState(false);
    const [showTimeOptions, setShowTimeOptions] = useState(false);
    const [showAreaOptions, setShowAreaOptions] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);

    // Close all dropdowns
    const closeAllOptions = () => {
        setShowDateOptions(false);
        setShowQuantityInput(false);
        setShowTimeOptions(false);
        setShowAreaOptions(false);
        setShowCalendar(false);
    };

    // Handle click outside dropdowns to close them
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (!e.target.closest('.order-table-row')) {
                closeAllOptions();
            }
        };
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const getNext10Days = () => {
        const days = [];
        const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
        for (let i = 0; i < 10; i++) {
            const date = new Date();
            date.setDate(date.getDate() + i);
            days.push(date.toLocaleDateString('he-IL', options));
        }
        return days;
    };

    const getTimeOptions = () => {
        return Array.from({ length: 96 }, (_, i) => {
            const hours = String(Math.floor(i / 4)).padStart(2, '0');
            const minutes = String((i % 4) * 15).padStart(2, '0');
            return `${hours}:${minutes}`;
        });
    };

    const goToNextPage = () => {
        if (currentPage < 3) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePlusClick = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setIsCompleted(true);
        }, 1000); // סימולציה של טעינה ואז הצלחה
    };

    return (
        <div className="order-table-container">
            {currentPage === 1 && (
                <div className="page-one">
                    {/* שדה קלט של מספר פלאפון עם כפתור */}
                    <div className="phone-input-section">
                        <input
                            type="tel"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            placeholder="הזן מספר פלאפון"
                            className="phone-input"
                        />
                        <button className="circle-button" onClick={handlePlusClick}>
                            {isLoading ? <FaSpinner className="spinner-icon" /> : isCompleted ? <FaCheck /> : <FaPlus />}
                        </button>
                    </div>

                    {/* אינפוטים נוספים */}
                    <div className="additional-inputs-row">
                        <input
                            type="text"
                            name="firstName"
                            placeholder="שם פרטי"
                            className="text-input"
                        />
                        <input
                            type="text"
                            name="lastName"
                            placeholder="שם משפחה"
                            className="text-input"
                        />
                        <input
                            type="number"
                            name="age"
                            placeholder="גיל"
                            className="text-input"
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="אימייל"
                            className="text-input"
                        />
                    </div>

                    {/* טבלת היסטוריית ביקורים */}
                    <div className="visit-history">
                        <h3>היסטוריית ביקורים</h3>
                        <table>
                            <thead>
                            <tr>
                                <th>תאריך</th>
                                <th>איזור</th>
                                <th>שעה</th>
                                <th>כמות אנשים</th>
                                <th>מספר שולחן</th>
                                <th>סטטוס</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>10/09/2023</td>
                                <td>בר</td>
                                <td>19:00</td>
                                <td>4</td>
                                <td>5</td>
                                <td>הושלם</td>
                            </tr>
                            <tr>
                                <td>15/08/2023</td>
                                <td>מרפסת</td>
                                <td>20:30</td>
                                <td>2</td>
                                <td>2</td>
                                <td>הושלם</td>
                            </tr>
                            <tr>
                                <td>22/07/2023</td>
                                <td>קפה</td>
                                <td>18:00</td>
                                <td>3</td>
                                <td>8</td>
                                <td>הושלם</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {currentPage === 2 && (
                <div className="page-two">
                    {/* סקשן ראשון - ארבעת כפתורי הבחירה */}
                    <div className="order-table-row">
                        {/* בחירת איזור */}
                        <div className="order-table-area">
                            <button
                                className="order-table-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeAllOptions();
                                    setShowAreaOptions(true);
                                }}
                            >
                                <FaMapMarkerAlt className="order-table-icon" />
                                {selectedArea || 'בחר איזור'}
                            </button>
                            {showAreaOptions && (
                                <ul className="order-table-area-options" onClick={(e) => e.stopPropagation()}>
                                    <li onClick={() => { setSelectedArea('בר'); closeAllOptions(); }}>בר</li>
                                    <li onClick={() => { setSelectedArea('בר - מרפסת'); closeAllOptions(); }}>בר - מרפסת</li>
                                    <li onClick={() => { setSelectedArea('בר - מלצרים'); closeAllOptions(); }}>בר - מלצרים</li>
                                    <li onClick={() => { setSelectedArea('קפה'); closeAllOptions(); }}>קפה</li>
                                    <li onClick={() => { setSelectedArea('קפה מרפסת עישון'); closeAllOptions(); }}>קפה מרפסת עישון</li>
                                </ul>
                            )}
                        </div>

                        {/* בחירת תאריך */}
                        <div className="order-table-date">
                            <button
                                className="order-table-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeAllOptions();
                                    setShowDateOptions(true);
                                }}
                            >
                                <FaCalendarAlt className="order-table-icon" />
                                {selectedDate || 'בחר תאריך'}
                            </button>
                            {showDateOptions && (
                                <ul className="order-table-date-options" onClick={(e) => e.stopPropagation()}>
                                    {getNext10Days().map((date, index) => (
                                        <li key={index} onClick={() => { setSelectedDate(date); closeAllOptions(); }}>{date}</li>
                                    ))}
                                    <li onClick={() => { setShowCalendar(true); setShowDateOptions(false); }}>אחר</li>
                                </ul>
                            )}
                            {showCalendar && (
                                <input
                                    type="date"
                                    className="order-table-calendar"
                                    value={customDate}
                                    onChange={(e) => { setCustomDate(e.target.value); setSelectedDate(e.target.value); setShowCalendar(false); }}
                                />
                            )}
                        </div>

                        {/* בחירת כמות */}
                        <div className="order-table-quantity">
                            {!showQuantityInput ? (
                                <button
                                    className="order-table-button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        closeAllOptions();
                                        setShowQuantityInput(true);
                                    }}
                                >
                                    <FaUser className="order-table-icon" />
                                    {selectedQuantity || 'בחר כמות'}
                                </button>
                            ) : (
                                <input
                                    type="number"
                                    className="order-table-quantity-input"
                                    value={customQuantity}
                                    onChange={(e) => setCustomQuantity(Math.max(0, parseInt(e.target.value, 10)))}
                                    placeholder="הכנס מספר"
                                    min="0"
                                />
                            )}
                            {showQuantityInput && (
                                <ul className="order-table-quantity-options" onClick={(e) => e.stopPropagation()}>
                                    {[...Array(10).keys()].map(i => (
                                        <li key={i} onClick={() => { setSelectedQuantity(i + 1); setShowQuantityInput(false); }}>{i + 1}</li>
                                    ))}
                                    <li onClick={() => setShowQuantityInput(true)}>אחר</li>
                                </ul>
                            )}
                        </div>

                        {/* בחירת שעה */}
                        <div className="order-table-time">
                            <button
                                className="order-table-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeAllOptions();
                                    setShowTimeOptions(true);
                                }}
                            >
                                <FaClock className="order-table-icon" />
                                {selectedTime || 'בחר שעה'}
                            </button>
                            {showTimeOptions && (
                                <ul className="order-table-time-options" onClick={(e) => e.stopPropagation()}>
                                    {getTimeOptions().map((time, index) => (
                                        <li key={index} onClick={() => { setSelectedTime(time); closeAllOptions(); }}>{time}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    {/* סקשן שני - התורים הקרובים */}
                    <div className="reservation-section">
                        <h3>התורים הקרובים</h3>
                        <div className="reservation-grid">
                            {[1, 2, 3, 4, 5].map((_, index) => (
                                <div className="reservation-card" key={index} onClick={() => alert('ריבוע נלחץ')}>
                                    <FaCalendarAlt className="reservation-icon" />
                                    <p>תאריך: {new Date().toLocaleDateString()}</p>
                                    <FaClock className="reservation-icon" />
                                    <p>שעה: 19:00</p>
                                    <FaMapMarkerAlt className="reservation-icon" />
                                    <p>איזור: בר</p>
                                    <FaUser className="reservation-icon" />
                                    <p>כמות אנשים: 4</p>
                                    <button className="reserve-button">לחץ לשמירת מקום</button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* כפתורי ניווט */}
            <div className="navigation-buttons">
                {currentPage > 1 && (
                    <button onClick={goToPreviousPage} className="previous-button">
                        הקודם
                        <FaArrowRight className="arrow-icon" />
                    </button>
                )}
                <button onClick={goToNextPage} className="next-button" style={{ marginLeft: '1rem' }}>
                    הבא
                    <FaArrowLeft className="arrow-icon" />
                </button>
                {currentPage === 2 && <span className="page-indicator">עמוד 2 מתוך 3</span>}
            </div>
        </div>
    );
};

export default OrderTable;
